<template>
<div class="container-fluid">
  <div class="row bookmark-box">
    <bookmark :ids='stepIds'></bookmark>
  </div>
  <br/><br/><br/><br/>
  <div id='mapa' v-bind:class="{ menutop: menutop}">&nbsp;</div>

  <div class="row box-container height-map" >
    <div class="col-lg-12 col-sm-12 box-divided" >
      <mapChart id="'map'"></mapChart>
    </div>
  </div>

  <!-- GRÁFICO DE TAXA DE FALHA -->
  <div class="row box-container " >
    <div class="col-lg-12 col-sm-12 box-divided" >
      <ChartFailure></ChartFailure>
    </div>
  </div>

  <!-- GRÁFICO DE TAXA DE FALHA POR PARETO (ANUAL ACUMULADO/MENSAL) 
  <div class="row box-container " >
    <div class="col-lg-12 col-sm-12 box-divided" >
      <ChartFailurePareto :online='false'></ChartFailurePareto>
    </div>
  </div>
  -->
  <!--#####################################################################-->
  <!--OS GRÁFICOS ABAIXO PEGA DA TABELA health.IGC_LY_FAM_2 QUE é construida a partir de uma materializada, PRECISA ALTERAR PARA POR O SETOR-->
    <div id='collect' v-bind:class="{ menutop: menutop}">&nbsp;</div>
    <div class="row box" >
      <div class="col-lg-4 col-sm-12 " >
        <!--SAMPLES-->
        <data-survey-chart title="Data Survey" gridtxt="Asset list data samples status." :data='general_report.coleta_chart' :filters="filters"></data-survey-chart>
      </div>
      <div class="col-lg-4 col-sm-12 ">
        <!--RESULT-->

        <transition name="show-from-left">
            <Popover name="helpfailure" :width="240">
                <Help :titleChart="'Failure Alarm (Analysis)'">
                  <div slot="content">
                    <p>{{ $t("28") }}</p>
                  </div>
              </Help>
            </Popover>
        </transition>

        <div class="title-charts title-bt-help">{{ $t("29") }}
          <button class="bt-help" v-popover:helpfailure.right><i class="icon-help ti-help-alt"></i></button>
        </div>

        <report-chart title="Failure Alarm (Analysis)" gridtxt="Asset list analysed status."  :data='general_report.result_chart' :filters="filters"></report-chart>
      </div>    

      <div class="col-lg-4 col-sm-12 ">
        <!--REPORTS-->
        <transition name="show-from-left">
            <Popover name="helpfailalarme" :width="240">
                <Help :titleChart="'Failure Alarm'">
                  <div slot="content">
                    <p>{{ $t("30") }}</p>
                  </div>
              </Help>
            </Popover>
        </transition>

        <div class="title-charts title-bt-help">{{ $t("31") }}
          <button class="bt-help" v-popover:helpfailalarme.bottom><i class="icon-help ti-help-alt"></i></button>
        </div>

        <report-chart title="Failure Alarm" gridtxt="Asset list condition status." :data='general_report.laudo_chart' :filters="filters"></report-chart>
      </div>
    <!-- ATÉ AQUI O USO DA TABELA -->
    <!--#####################################################################-->
  </div>
  <div id='planning' v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <div class="row box" >
    <div class="col-lg-12 col-sm-12" >
      <!--Planning/Execution-->
      <chartsReport ></chartsReport>
      <br/>
      <div class="row">
          <div class="col-lg-2 col-sm-12" v-for="(item, key, index) in planned_rdps_data" :key="index" style='padding: 10px;'>
              <Donut :id="String(item.id)" :title="item.name" :pendente="item.pendente" :programado="item.programado" :filters="filters"></Donut>
          </div>
      </div>
      <div class="row box-container">
        <div class="col-lg-12 col-sm-12 box-divided" >
          <ChartBacklog :online='false'></ChartBacklog>
        </div>
      </div>
    </div>
  </div>
  
  <div id="defects" v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <div class="row box">
    <div class="col-lg-12 col-sm-12 height-box">
      <!--DEFECTS FOUND-->
      <chartsDefects></chartsDefects>
    </div>
  </div>

  <br>
  <!-- Recurrence Rate -->
  <div class="row box">
    <div class="col-lg-12 col-sm-12">

      <transition name="show-from-left">
          <Popover name="repetition" :width="240">
              <Help :titleChart="'Recurrence Rate of Interventions'">
                <div slot="content">
                  <p>{{ $t("32") }}</p>
                </div>
            </Help>
          </Popover>
      </transition>

      <div class="title-charts title-bt-help">{{ $t("33") }}
        <button class="bt-help" v-popover:repetition.right><i class="icon-help ti-help-alt"></i></button>
      </div>

      <!-- Reincidencia Indicator -->
      <div class="col-lg-5ths col-md-5ths col-sm-12" v-for="(item, key, index) in repetition_data" :key="index" style='margin-top: 30px !important'>
        <ReincidenciaIndicator :title="key" :content="item[0]" :perc="item[1]"></ReincidenciaIndicator>
      </div>
      <br/>

      <div class="row">
        <div class="col-lg-12 col-sm-12 box-divided" >
          <ChartReincidenciaPareto :online='false'></ChartReincidenciaPareto>
        </div>
      </div>

      <!-- Reincidencia Chart -->
      <div class="col-lg-4 col-md-4 col-sm-12" v-for="item in repetition_chart_data" :key="item.id">
        <ReincidenciaChart :title="item.title" :data="item.data" :plant="item.plant"></ReincidenciaChart>
      </div>

    </div>
  </div>

 <!--  <div v-bind:class="{ menutop: menutop}">&nbsp;</div>
  <div class="row box">
    <div class="col-lg-12 col-sm-12 height-box">
      SKIPPED
      <chartsSkipped></chartsSkipped>
    </div>
  </div> -->
  <div id='execution' v-bind:class="{ menutop: menutop}">&nbsp;</div>

  <!-- Report Execution Deadline -->
  <div class="row box" >
    <div class="col-lg-12 col-sm-12">

      <transition name="show-from-left">
          <Popover name="execution_deadline" :width="240">
              <Help :titleChart="'Execution'">
                <div slot="content">
                  <p>{{ $t("34") }}</p>
                </div>
            </Help>
          </Popover>
      </transition>

      <div class="title-charts">{{ $t("35") }}
        <button class="bt-help" v-popover:execution_deadline.right><i class="icon-help ti-help-alt"></i></button>
      </div>
    
      <br>
      <!-- Indicadores Excution Totais -->
      <div class="row">

        <div class="col-lg-6 col-md-6 col-sm-12">

          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="0" title="On Time" :content="reports_execution_deadline.total[0]" color="#90ed7d" font='24px'></ReincidenciaIndicator>
            </div>
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="1" title="1 to 15 days late" :content="reports_execution_deadline.total[1]" color="#f0893a" font='24px'></ReincidenciaIndicator>
            </div>
          </div>
          
          <br>

          <div class="row">
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="2" title="15 to 30 days late" :content="reports_execution_deadline.total[2]" color="#f45b5b" font='24px'></ReincidenciaIndicator>
            </div>
            <div class="col-lg-6 col-sm-12">
              <ReincidenciaIndicator :delay="3" title="> 30 days late" :content="reports_execution_deadline.total[3]" color="#f45b5b" font='24px'></ReincidenciaIndicator>
            </div>
          </div>

        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <DonutExecution 
            title="" 
            :data="[reports_execution_deadline.total_concluido, reports_execution_deadline.total_atrasado]"
            :filters="filters"
          >
          </DonutExecution>
        </div>

      </div>
      
      <br/>
      <br/>
      <transition name="show-from-left">
          <Popover name="execution_deadline_total" :width="240">
              <Help :titleChart="'Comparison Charts - On time | late'">
                <div slot="content">
                  <p>{{ $t("36") }}</p>
                </div>
            </Help>
          </Popover>
      </transition>

      <div class="title-charts">{{ $t("37") }}
        <button class="bt-help" v-popover:execution_deadline_total.right><i class="icon-help ti-help-alt"></i></button>
      </div>

      <!-- Execution Chart Total -->
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12" v-for="(item, index) in reports_execution_deadline.details_total" :key="index">
          <ExecutionChartTotal :title="item.name" :data="[item['onTime'], item['late']]" :id="String(item.id)" :filters="filters"></ExecutionChartTotal>
        </div>
      </div>

      <br/>
      <br/>

      <div class="title-charts">{{ $t("38") }}
        <button class="bt-help" v-popover:execution_deadline_details.right><i class="icon-help ti-help-alt"></i></button>
        <transition name="show-from-left">
            <Popover name="execution_deadline_details" :width="240">
                <Help :titleChart="'Comparison Charts by Period'">
                  <div slot="content">
                    <p>{{ $t("39") }}</p>
                  </div>
              </Help>
            </Popover>
        </transition>
      </div>

      <!-- Execution Chart -->
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12" v-for="(item, index) in reports_execution_deadline.details" :key="index">
          <ExecutionChart :title="item.name" :data="[item[0], item[1], item[2], item[3]]" :id="String(item.id)" :filters="filters"></ExecutionChart>
        </div>
      </div>

    </div>
  </div>

  <br/>
  <div class="row box" >
    <!--Execution-->
    <div class="col-lg-12 col-sm-12" id='execution'>
        <ExecutionIndicators></ExecutionIndicators>
    </div>
  </div>
  <br/>
  <DescontinuationWarning></DescontinuationWarning>
</div>
</template>

<script>
import {Chart} from 'highcharts-vue'
import mapChart from 'src/components/Dashboard/Views/Maps/MapChart'
import ReportChart from 'src/components/Dashboard/Views/Charts/ReportChart'
import DataSurveyChart from 'src/components/Dashboard/Views/Charts/DataSurveyChart'
import ChartsSkipped from 'src/components/Dashboard/Views/Charts/ChartsSkipped'
import chartsReport from 'src/components/Dashboard/Views/Charts/chartsReport'
import chartsDefects from 'src/components/Dashboard/Views/Charts/chartsDefects'
import bookmark from 'src/components/Dashboard/Views/Components/Bookmark'
import ExecutionIndicators from '../Components/ExecutionIndicators'
import Donut from 'src/components/Dashboard/Views/Charts/Donut'
import ReincidenciaIndicator from 'src/components/Dashboard/Views/Components/ReincidenciaIndicator'
import ReincidenciaChart from 'src/components/Dashboard/Views/Charts/ReincidenciaChart'
import Help from 'src/components/Dashboard/Views/components/Help'
import Vue from 'vue';
import ExecutionChart from 'src/components/Dashboard/Views/Charts/ExecutionChart'
import DonutExecution from 'src/components/Dashboard/Views/Charts/DonutExecution'
import ExecutionChartTotal from 'src/components/Dashboard/Views/Charts/ExecutionChartTotal'
import ChartFailure from 'src/components/Dashboard/Views/Charts/ChartFailure'
import ChartBacklog from 'src/components/Dashboard/Views/Charts/ChartBacklog'
import ChartReincidenciaPareto from 'src/components/Dashboard/Views/Charts/ChartReincidenciaPareto'
import ChartFailurePareto from 'src/components/Dashboard/Views/Charts/ChartFailurePareto'
import DescontinuationWarning from 'src/components/Dashboard/Views/Components/DescontinuationWarning.vue'

import Popover  from 'vue-js-popover'
Vue.use(Popover)


import { mapMutations, mapGetters } from 'vuex';
import axios from 'axios';

import mixin from '../../../../utils/mixin';

export default {
  name: 'app',
  options: null,
  components: {
    highcharts: Chart,
    mapChart: mapChart,
    ReportChart: ReportChart,
    chartsSkipped: ChartsSkipped,
    chartsReport: chartsReport,
    chartsDefects: chartsDefects,
    bookmark: bookmark,
    ExecutionIndicators,
    Donut,
    ReincidenciaIndicator,
    ReincidenciaChart,
    popover: Popover,
    Help,
    ExecutionChart,
    DonutExecution,
    ExecutionChartTotal,
    ChartFailure,
    DataSurveyChart,
    ChartBacklog,
    ChartReincidenciaPareto,
    ChartFailurePareto,
    DescontinuationWarning,
  },
  data () {
    return {
      stepIds: ['collect', 'reports', 'defects', '', 'planning', 'execution', 'mapa'],
      menutop: false,
      planned_rdps_data: [],
      repetition_data: {},
      repetition_chart_data: [],
      general_report: {
        coleta_chart: [],
        laudo_chart: [],
        result_chart: []
      },
      reports_execution_deadline: {
        total: {},
        details: [],
        total_atrasado: 0,
        total_concluido: 0,
        details_total: []
      }
    }
  },
  mixins: [mixin],
  mounted: function () {
    //this.showNotification();
    this.changeTab('offline');
  },
  methods: {
    get_planned_reports: function() {
      const API = process.env.ROOT_API;

      const ENDPOINT = 'v1/mysemeq-ambev/get-planned-reports'
      let self = this;

      self.planned_rdps_data = [];
      axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(resp => {
        self.planned_rdps_data = resp.data;
      })
      .catch(err => {
        self.ApiErrorHandler(self, error.response.data.status_code);
      })
    },
    get_repetition: function() {
      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-repetition'
      let self = this;

      this.repetition_data = [];
      this.repetition_chart_data = [];
      axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(res => {
        let repetition = res.data.total;

        let repetition_chart_data = [];
        for(let i in res.data.detail) {
          let dados = res.data.detail[i];

          repetition_chart_data.push({
            id: i,
            title: dados.plant,
            plant: dados.plant_id,
            data: [
              [dados['R1'], dados['R2'], dados['R3'], dados['R3+']],
              [dados['R1_perc'], dados['R2_perc'], dados['R3_perc'], dados['R3+_perc']]
            ]
          });

        }

        self.repetition_chart_data = repetition_chart_data;

        self.repetition_data = {
          'R0': [repetition['R0'] - 1, repetition['R0_perc']],
          'R1': [repetition['R1'], repetition['R1_perc']],
          'R2': [repetition['R2'], repetition['R2_perc']],
          'R3': [repetition['R3'], repetition['R3_perc']],
          'R3+': [repetition['R3+'], repetition['R3+_perc']]
        };

      })
      .catch(error => {
        self.ApiErrorHandler(self, error.response.data.status_code);
      })
    },
    get_general_report: function() {

      const API = process.env.ROOT_API;
 
      if(this.filters.area || this.filters.sector || this.filters.machine || this.filters.component ){
        const ENDPOINT = 'v1/mysemeq-ambev/get-general-report-chart-filter' 

        let self = this;
        axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          self.general_report = resp.data;
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, error.response.data.status_code);
        })
      }
      else{
        const ENDPOINT = 'v1/mysemeq-ambev/get-general-report-chart' 

        let self = this;
        axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
        .then(resp => {
          self.general_report = resp.data;
        })
        .catch(err => {
          // from mixin
          self.ApiErrorHandler(self, error.response.data.status_code);
        })
      }  
    },
    get_executed_reports: function() {

      const API = process.env.ROOT_API;
      const ENDPOINT = 'v1/mysemeq-ambev/get-executed-reports-deadline'

      this.reports_execution_deadline = {total: {}, details: [], details_total: []};
      this.reports_execution_deadline.total_atrasado = 0;
      this.reports_execution_deadline.total_concluido = 0;

      let self = this;
      axios({method: 'GET', url: API + ENDPOINT, params: this.filters, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(res => {
        self.reports_execution_deadline = res.data;

        self.reports_execution_deadline.total_atrasado = res.data.total[1] + res.data.total[2] + res.data.total[3];
        self.reports_execution_deadline.total_concluido = res.data.total[0];
      })
      .catch(err => {
        self.ApiErrorHandler(self, error.response.data.status_code);
      })
    },
    showNotification: function () {
      this.$notify({
        message: this.$i18n.t("48"),
        type: "warning",
        top: true,
        showClose: true,
        fullWidth: true,
        closeDelay: 9999999999999,
      });
    },
    ...mapMutations(['changeTab']),
  },
  computed: {
    ...mapGetters(['filters', 'menu']),
  },
  watch: {
    menu: function(newValue){
      //console.log('scroll', this.menu.book)
      if(this.menu.book > 30){
        this.menutop = true
      }
      if(this.menu.book < 29){
        this.menutop = false
      }
    }, 
    filters: function(){
      this.get_planned_reports();
      this.get_repetition();
      this.get_general_report();
      this.get_executed_reports();
    }
  }
}
</script>
<style scoped>
  .menutop{
    /* padding-top: 25px; */
    position: relative;
    bottom: 35px;
  }
  * {
    box-sizing: border-box;
  }
  .height-box {
    height: auto;
  }
  .height-box-top {
    height: 490px;
  }

  /* cor de fundo para grupo de gráficos */
  .box {
    background-color: #2a2a2e;
    padding: 15px 0;
  }
  .box-container {
    display: flex;
  }
  .box-divided {
    background-color: #2a2a2e;
    padding: 15px 0;
    position: relative;
    width: 100%;
  }
  .height-map{
    height: 420px;
   margin-top: 5px;
   /* margin-top: 0px;*/
  }

  .bookmark-box{
    position: fixed;
    top: 0%;
    margin:0px auto;
    z-index: 9999999;
    background-color: #000;
    width: 75%;
  }

  div[data-popover="repetition"]{
    left: 66% !important;
    top: 0% !important;
  }

 div[data-popover="execution_deadline"] {
    left: 57% !important;
    top: 0% !important;
  }

  div[data-popover="execution_deadline_total"] {
    left: 66% !important;
    top: 382px !important;
  }

  div[data-popover="execution_deadline_details"] {
    left: 69% !important;
    top: 0% !important;
  } 

  div[data-popover="helpfailure"] {
    left: 81% !important;
    top: 0% !important;
  } 

  div[data-popover="helpfailalarme"] {
    left: 29% !important;
    top: 6% !important;
  }

  

  @media screen and (max-width: 1175px) {
    .bookmark-box{
      top: 35px;
      width: 70%;
    }
    .height-map{
      margin-top: 40px;
    }
  }

  @media screen and (max-width: 992px) {
    .bookmark-box{
      width: 90%;
    }
  }

  @media screen and (max-width: 422px) {
    .bookmark-box{
      width: 80%;
    }
  }

  
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Home.vue